import { TActionsMenuSelectionGuide } from './entity.model';

export type TActionsMenuSelectionRequired = TActionsMenuSelectionGuide & {
  triggerHighlighted: boolean;
  actionLabel: string;
  actionIcon: string;
};

export enum EActionsMenuRowState {
  Idle = 'idle',
  Waiting = 'waiting',
  Loading = 'loading',
  Confirm = 'confirm',
  Done = 'done',
  Empty = 'empty',
  SelectionRequired = 'selection-required',
  Error = 'error',
  Blocked = 'blocked',
}

export type TActionsMenuRun = {
  id: string;
  loadingKey: string;
  loading: boolean;
  longWait: boolean;
};

export type TActionsMenuRecord = {
  state: EActionsMenuRowState.Done | EActionsMenuRowState.Empty | EActionsMenuRowState.SelectionRequired | EActionsMenuRowState.Error;
  messageKey: string;
  hintKey: string;
  count: number;
  failures: number;
  seen: boolean;
};

export type TActionsMenuConfirm = {
  id: string;
  total: number;
  limit: number;
};

export type TActionsMenuBlocked = {
  id: string;
  runningId: string;
};

export type TActionsMenuRowView = {
  state: EActionsMenuRowState;
  rowClass: string;
  buttonClass: string;
  tileClass: string;
  icon: string;
  spinner: boolean;
  statusKey: string;
  statusClass: string;
  secondLineKey: string;
  count: number;
  total: number;
  limit: number;
  action: string;
  busy: boolean;
  showBadge: boolean;
  showRetry: boolean;
  showConfirm: boolean;
};

export type TActionsMenuTrigger = {
  busy: boolean;
  error: boolean;
  tooltip: string;
};

export const ACTIONS_MENU_LOADING_DELAY_MS = 300;
export const ACTIONS_MENU_MIN_LOADING_MS = 500;
export const ACTIONS_MENU_LONG_WAIT_MS = 8000;
export const ACTIONS_MENU_BLOCKED_MS = 3000;

export type TActionsMenuScopeCopy = {
  generalGroup: string;
  selectionGroup: string;
  refreshDescription: string;
  rememberFilterDescription: string;
};

export type TActionsMenuLayoutInput = {
  allowExport: boolean;
  showRefreshButton: boolean;
  hasRememberFilter: boolean;
  selectionCount: number;
  generalCount: number;
};

export type TActionsMenuLayout = {
  exportGroup: boolean;
  selectionGroup: boolean;
  generalGroup: boolean;
  refresh: boolean;
  selectionDivider: boolean;
  generalDivider: boolean;
  refreshDivider: boolean;
  refreshHeading: boolean;
  hasActions: boolean;
};

export const ACTIONS_MENU_REMEMBER_FILTER_SWITCH_ID = 'dx-actions-menu-remember-filter';
